import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import MobilePetCustomizer from '../components/customizer/MobilePetCustomizer';
import PetCustomizer from '../components/customizer/PetCustomizer';
import APICustomizerWrapper from '../components/customizer/APICustomizerWrapper';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import './Customizer.scss';
import { useDispatch, useSelector } from 'react-redux';
import { changeCustomizerStep, setCustomizerStep } from '../store/customizerSlice';
import arrow_left from '/icons/arrow-left.svg';
import BackMobileButton from '../components/ui/BackMobileButton';
import { scrollToTop } from '../utils/scrollToTop';

const breadcrumbs = [
  { label: "Customizer", link: "/customizer" },
];

function Customizer({ isMobile }) {
  const dispatch = useDispatch();
  const customizerStep = useSelector((state) => state.customizer.customizerStep);
  const [searchParams] = useSearchParams();
  
  // Check if we're in API/iframe mode
  const apiMode = searchParams.get('apiMode') === 'true';

  // Hide header/footer when in API mode (iframe embed)
  useEffect(() => {
    if (apiMode) {
      document.body.classList.add('api-mode');
    }
    return () => {
      document.body.classList.remove('api-mode');
    };
  }, [apiMode]);

  // If API mode, use the API wrapper (handles both mobile and desktop)
  if (apiMode) {
    return <APICustomizerWrapper isMobile={isMobile} />;
  }

  return (
    <section className="customizer-page full-width flex flex-col gap-5 md:gap-7 items-center pt-5 md:pt-10">

      {!isMobile &&
        <div className="flex flex-col gap-5 contained-width">
          <Breadcrumbs items={breadcrumbs} />
          <div className="flex flex-col gap-5 items-center">
            <h2 className="text-center">Create your custom pet product</h2>
            <p className="text-center text-base md:text-mid mb-0" style={{ maxWidth: '700px' }}>Creating your custom pet product takes just three simple steps - upload photo, adjust, and choose a product type. That's it!</p>
          </div>
        </div>
      }

      {isMobile && customizerStep === 1 &&
        <div className="flex flex-col gap-5 contained-width fade-step">
          <div className="flex flex-col gap-3 items-center">
            <h2 className="text-center text-3xl font-medium">Step 1: Position Your Photo and Select a Frame</h2>
            <p className="text-center text-base md:text-mid mb-0" style={{ maxWidth: '700px' }}>Upload and position the photo of your pet, then select the frame you prefer - we offer a variety of options.</p>
          </div>
        </div>
      }

      {isMobile && customizerStep !== 1 &&
        <div className="flex flex-col gap-5 contained-width fade-step">
          <div className="flex flex-col gap-5 items-center">
            <h2 className="text-center text-3xl font-medium">Step 2: Select <nobr>Pet Type</nobr> and Add Your Pet's Name</h2>
            <p className="text-center text-base md:text-mid mb-0" style={{ maxWidth: '700px' }}>Optionally personalize your design by adding your pet's name and select your pet type - dog or cat.</p>
          </div>
        </div>
      }

      {isMobile ?
        <MobilePetCustomizer />
        :
        <PetCustomizer />
      }

      {isMobile && customizerStep === 2 &&
        <BackMobileButton onClick={() => {
          dispatch(setCustomizerStep(1));
          scrollToTop();
        }} />
      }

    </section>
  );
}

export default Customizer
